<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0 text-uppercase">
                échantillions
            </h5>
        </mat-card-title>
        <mat-card-subtitle>
            <!--            <button type="button" mat-button class="card-header-menu-btn mr-5" [matMenuTriggerFor]="cardHeaderMenu">-->
            <!--                Show All-->
            <!--            </button>-->
            <!--            <mat-menu #cardHeaderMenu="matMenu" class="card-header-menu" xPosition="before">-->
            <!--                <button mat-menu-item>-->
            <!--                    Shipped-->
            <!--                </button>-->
            <!--                <button mat-menu-item>-->
            <!--                    Confirmed-->
            <!--                </button>-->
            <!--                <button mat-menu-item>-->
            <!--                    Pending-->
            <!--                </button>-->
            <!--                <button mat-menu-item>-->
            <!--                    Rejected-->
            <!--                </button>-->
            <!--            </mat-menu>-->
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0" placeholder="chercher un sample" (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>

                    <!-- ID Column
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                    </ng-container>-->

                    <!-- Identification Column
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Identification </th>
                        <td mat-cell *matCellDef="let element">
                            <a (click)="viewSampleDetails(element.id)" class="sample-link">
                                {{element.id}}
                            </a>
                        </td>
                    </ng-container>-->

                    <!-- Social Reason Column -->
                    <ng-container matColumnDef="collected_by">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Collecté par </th>
                        <td mat-cell *matCellDef="let element"> {{element.collected_by}} </td>
                    </ng-container>

                    <!-- HeadQuarter Column -->
                    <ng-container matColumnDef="collection_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> collection_date </th>
                        <td mat-cell *matCellDef="let element"> {{element.collection_date}} </td>
                    </ng-container>

                    <!-- Phone Column -->
                    <ng-container matColumnDef="comments">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Commentaires </th>
                        <td mat-cell *matCellDef="let element"> {{element.comments}} </td>
                    </ng-container>

                    <!-- Fax Column -->
                    <ng-container matColumnDef="creation_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de création </th>
                        <td mat-cell *matCellDef="let element"> {{element.creation_date}} </td>
                    </ng-container>

                    <!-- Mail Column -->
                    <ng-container matColumnDef="sample_code ">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
                        <td mat-cell *matCellDef="let element"> {{element.sample_code}} </td>
                    </ng-container>

                    <!-- Activity Field Column -->
                    <ng-container matColumnDef="sample_type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                        <td mat-cell *matCellDef="let element"> {{element.sample_type}} </td>
                    </ng-container>

                    <!-- VAT Column -->
                    <ng-container matColumnDef="source">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Source </th>
                        <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                    </ng-container>

                    <!-- Address Column -->
                    <ng-container matColumnDef="storage_conditions">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Conditins de stockage </th>
                        <td mat-cell *matCellDef="let element"> {{element.storage_conditions}} </td>
                    </ng-container>

                    <!-- Billing Address Column -->
                    <ng-container matColumnDef="billingAddress">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Billing Address </th>
                        <td mat-cell *matCellDef="let element"> {{element.billingAddress}} </td>
                    </ng-container>

                    <!-- Flag Column -->
                    <ng-container matColumnDef="flag">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Flag </th>
                        <td mat-cell *matCellDef="let element"> {{element.flag}} </td>
                    </ng-container>

                    <!-- Creation Date Column -->
                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Creation Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.creationDate}} </td>
                    </ng-container>

                    <!-- Update Date Column -->
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Update Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.updateDate}} </td>
                    </ng-container>

                    <!-- Created By Column -->
                    <ng-container matColumnDef="createdBy">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                        <td mat-cell *matCellDef="let element"> {{element.createdBy.name}} </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
                        <td mat-cell *matCellDef="let element" >
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Modifier"  matTooltipPosition="above" (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined">
                                        {{element.action.edit}}
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer"  matTooltipPosition="above" (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined">
                                        {{element.action.delete}}
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7">Aucun résultat trouvé pour "{{input.value}}"</td>
                    </tr>

                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>

</mat-card>


<!-- template for edit -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Update sample
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="onEditSubmit(modal)">
                <div class="row">
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Identification</mat-label>
                            <input matInput formControlName="identification" placeholder="Ex. 123456789">
                            <mat-error *ngIf="editForm.get('identification')?.hasError('required')">Identification is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Social Reason</mat-label>
                            <input matInput formControlName="socialReason" placeholder="Ex. Example Corp">
                            <mat-error *ngIf="editForm.get('socialReason')?.hasError('required')">Social Reason is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Head Quarter</mat-label>
                            <input matInput formControlName="headQuarter" placeholder="Ex. 123 Main St, Springfield">
                            <mat-error *ngIf="editForm.get('headQuarter')?.hasError('required')">Head Quarter is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Phone</mat-label>
                            <input matInput formControlName="phone" placeholder="Ex. 123-456-7890">
                            <mat-error *ngIf="editForm.get('phone')?.hasError('required')">Phone is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Fax</mat-label>
                            <input matInput formControlName="fax" placeholder="Ex. 098-765-4321">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>E-mail</mat-label>
                            <input type="email" matInput formControlName="mail" placeholder="Ex. info@example.com">
                            <mat-error *ngIf="editForm.get('mail')?.hasError('required')">Email is required</mat-error>
                            <mat-error *ngIf="editForm.get('mail')?.hasError('email')">Invalid email format</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Activity Field</mat-label>
                            <input matInput formControlName="activityField" placeholder="Ex. Software Development">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>VAT</mat-label>
                            <input matInput formControlName="vat" placeholder="Ex. 1234567890123456789012">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Address</mat-label>
                            <textarea matInput formControlName="address" placeholder="Ex. 123 Main St, Springfield"></textarea>
                            <mat-error *ngIf="editForm.get('address')?.hasError('required')">Address is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Billing Address</mat-label>
                            <textarea matInput formControlName="billingAddress" placeholder="Ex. 456 Elm St, Springfield"></textarea>
                            <mat-error *ngIf="editForm.get('billingAddress')?.hasError('required')">Billing Address is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Flag</mat-label>
                            <mat-select formControlName="flag">
                                <mat-option [value]="1">Active</mat-option>
                                <mat-option [value]="0">Inactive</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-12 text-right">
                    <button type="submit" class="btn btn-outline-success">Enregister</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>
